import * as React from "react";

import { InvalidProgramStateError } from "../../../../../Common/Errors";

import { ITourElementsRegistry } from "./ITourElementsRegistry";
import { TourElementsRegistry } from "./TourElementsRegistry";

const TourElementsRegistryContext = React.createContext<ITourElementsRegistry | undefined>(undefined);

export function useTourElementsRegistry(): ITourElementsRegistry {
    const result = React.useContext(TourElementsRegistryContext);
    if (result == undefined) {
        throw new InvalidProgramStateError();
    }
    return result;
}

interface TourElementsRegistryContextProviderProps {
    children: React.ReactNode;
}

export function TourElementsRegistryContextProvider(props: TourElementsRegistryContextProviderProps): JSX.Element {
    const tourElementsRegistry = React.useMemo(() => new TourElementsRegistry(), []);

    return (
        <TourElementsRegistryContext.Provider value={tourElementsRegistry}>
            {props.children}
        </TourElementsRegistryContext.Provider>
    );
}
